import styled from 'styled-components';

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 24px;
  height: 100%;
`;

export const SlideoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  & > div:nth-child(2) > div {
    border-radius: 8px;
    border-color: ${(props) => props.theme.colors.davysGrey};
  }
`;

export const SlideoutSubHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SlideoutDrivesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  min-height: 0;
`;

